// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { ShellContext } from "@insite/client-framework/Components/IsInShell";
import useIsScrollTop from "@store/Framework/Common/Hooks/useIsScrollTop";
import { isFullOpacitySelector } from "@store/Framework/Store/Bunzl/Components/Header/HeaderSelectors";
import { HeaderIsFullOpacityParameter } from "@store/Framework/Store/Bunzl/Components/Header/HeaderTypes";
import useDispatchHeaderFullOpacity from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useDispatchHeaderFullOpacity";
import { useContext, useEffect, useState } from "react";

/**
 * @param additionalCondition An addional condition to set the header opac. Default value: false
 */

export default (additionalCondition = false) => {
    const isFullOpacity = useAppSelector(state => isFullOpacitySelector(state));

    const [activeElements] = useState({});
    const [isManuallyFullOpacity, setIsManuallyFullOpacity] = useState<boolean>(false);
    const [hasActiveElement, setHasActiveElement] = useState<boolean>(
        (typeof window !== "undefined" &&
            document.querySelector("#headerContainer")?.contains(document.activeElement)) ||
            false,
    );

    const shellContext = useContext(ShellContext);
    const isEditing = shellContext.isEditing || false;

    const dispatchHeaderFullOpacity = useDispatchHeaderFullOpacity();
    const isScrollTop = useIsScrollTop();

    useEffect(() => {
        if (typeof window === "undefined") {
            return;
        }
        const anyHeaderElementOnFocus =
            document.querySelector("#headerContainer")?.contains(document.activeElement) || false;
        if (anyHeaderElementOnFocus !== hasActiveElement) {
            setHasActiveElement(anyHeaderElementOnFocus);
        }
    }, [isScrollTop, activeElements]);

    useEffect(() => {
        const headerIsFullOpacityParameter: HeaderIsFullOpacityParameter =
            !isScrollTop || hasActiveElement || isEditing || additionalCondition;

        if (isManuallyFullOpacity) {
            dispatchHeaderFullOpacity(isManuallyFullOpacity);
        } else {
            dispatchHeaderFullOpacity(headerIsFullOpacityParameter);
        }
    }, [isScrollTop, hasActiveElement, isEditing, isManuallyFullOpacity]);

    return {
        isFullOpacity,
        manuallySetFullOpacity: (value: boolean) => {
            setIsManuallyFullOpacity(value);
        },
    };
};
